<app-navbar></app-navbar>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="overflow-hidden w-100 bg-white text-nowrap mt-5">
                    <div class="fade-left position-absolute z-2"></div>
                    <div class="fade-right position-relative float-end z-2"></div>
                    <div class="jumbotron-track d-inline-block">
                        <span class="d-inline-block">
                            <div class="pb-5 jumbotron-img jumbotron-slide">
                                <div class="fade-top"></div>
                                <div class="fade-bottom"></div>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="pt-5 pb-3 mt-5 mb-5">
                    <div class="container p-0">
                        <div class="row">
                            <div class="col-6">
                                <h4 class="fs-4 fw-semibold mb-4">Get the latest updates</h4>
                            </div>
                            <div class="col-6">
                                <a [routerLink]="['/articles', 3, 1]"  class="float-end mt-4 text-decoration-none text-secondary inter fs-6">View all updates <img src="assets/icons/arrow-right.svg" alt="Read more"></a>
                            </div>
                        </div>
                        <div class="row">
                            @for (obj of articles(); track obj.slug) {
                                <div class="col-lg-3">
                                    <a [routerLink]="['/article', obj.categorySlug, obj.slug]" class="text-decoration-none">
                                        <div class="latest mb-4 bg-white">
                                            <div class="thumbnail bg-white rounded-2 mb-3">
                                                <img [src]="obj.img" [alt]="obj.title" class="object-fit-cover w-100 rounded-top">
                                            </div>
                                            <div class="inter">
                                                <h4 class="fs-5 fw-semibold px-3 cl-1">{{obj.title | truncate: 23}}</h4>
                                                <div class="summary">
                                                    <p class="fs-6 text-dark lh-lg px-3 mb-0 inter cl-2">{{obj?.summary! | truncate: 60}}</p>
                                                </div>
                                                <div class="px-3 py-3 d-lock">
                                                    <span class="me-2 read-more text-secondary fs-7">Read more</span>
                                                    <img src="assets/icons/arrow-right.svg" alt="Read more">
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="text-center mb-5 mt-5 pt-4">
                    <h3 class="fs-2 fw-semibold ">Available in all leading drugstores and ecommerce nationwide</h3>
                </div>
            </div>
        </div>
    </div>
    <div class="container mb-5">
        <div class="row">
            <div class="col-lg-3 col-xs-6 mb-4">
                <a href="https://shopee.ph/bewellnutraceuticalscorp">
                    <img src="assets/ecommerce/shopee.png" alt="Bewell Shopee" class="img-fluid rounded rounded-3 border border-light box-shadow">
                </a>
            </div>
            <div class="col-lg-3 col-xs-6 mb-4">
                <a href="https://www.tiktok.com/@bewell_shop">
                    <img src="assets/ecommerce/tiktok-shop.png" alt="Bewell Tiktok" class="img-fluid rounded rounded-3 border border-light box-shadow">
                </a>
            </div>
            <div class="col-lg-3 col-xs-6 mb-4">
                <a href="https://www.lazada.com.ph/bewell">
                    <img src="assets/ecommerce/lazada.png" alt="Bewell Lazada" class="img-fluid rounded rounded-3 border border-light box-shadow">
                </a>
            </div>
            <div class="col-lg-3 col-xs-6 mb-4">
                <a href="http://shop.bewell.com.ph">
                    <img src="assets/ecommerce/bewell-express.png" alt="Bewell Express" class="img-fluid rounded rounded-3 border border-light box-shadow">
                </a>
            </div>
            <div class="col-lg-3 col-xs-6 mb-4">
                <img src="assets/drugstores/mercury.webp" alt="Mercury Drug" class="img-fluid rounded rounded-3 border border-light box-shadow">
            </div>
            <div class="col-lg-3 col-xs-6 mb-4">
                <img src="assets/drugstores/watsons.webp" alt="Watsons Pharmacy" class="img-fluid rounded rounded-3 border border-light box-shadow">
            </div>
            <div class="col-lg-3 col-xs-6 mb-4">
                <img src="assets/drugstores/south-star.webp" alt="South Start Drug" class="img-fluid rounded rounded-3 border border-light box-shadow">
            </div>
            <div class="col-lg-3 col-xs-6 mb-4">
                <img src="assets/drugstores/rose-pharmacy.webp" alt="Rose Pharmacy" class="img-fluid rounded rounded-3 border border-light box-shadow">
            </div>
        </div>
    </div>
<app-footer></app-footer>